import { NotificationType } from '@naturehouse/design-system/components/atoms/notification/Notification';
import { StatusPanelVariant } from '@naturehouse/design-system/components/molecules/status-panel/StatusPanel';
import statusPanelTemplate from '@naturehouse/design-system/components/molecules/status-panel/StatusPanel.html.njk';
import HttpClient from '@naturehouse/design-system/js/utils/HttpClient';
import createNotification from '../../../util/notification';
import ModalComponent from '../../shared/components/ModalComponent';

export default class AcceptBookingComponent extends ModalComponent {
    #notificationElement: HTMLElement | undefined | null;

    protected onModalOpened(): void {
        this.#notificationElement = this.modalElement?.querySelector('[data-role="notification"]');
        this.setEventListeners();
    }

    protected onSuccess(): void {
        super.onSuccess();
        this.closeDialog();

        createNotification(NotificationType.SUCCESS, this.context.bindings.successMessage);

        const tableRow = this.context.element.closest('tr');

        if (!tableRow) {
            setTimeout(() => {
                window.location.reload();
            }, 500);
            return;
        }

        tableRow.parentElement?.removeChild(tableRow);
    }

    private setEventListeners(): void {
        if (!this.modalElement) {
            return;
        }

        const submitButton: HTMLButtonElement | null =
            this.modalElement.querySelector('button[type="submit"]');

        submitButton?.addEventListener('click', () => {
            this.#clearErrorMessage();

            submitButton.disabled = true;
            this.submitButtonIconToggle(submitButton);

            HttpClient.post(this.context.bindings.endpoint)
                .then(() => {
                    this.submitButtonIconToggle(submitButton);
                    this.onSuccess();
                })
                .catch((e: AjaxResponseError) => {
                    submitButton.disabled = false;
                    this.submitButtonIconToggle(submitButton);
                    this.#setErrorNotification(e.message);
                });
        });
    }

    #clearErrorMessage(): void {
        if (!this.#notificationElement) {
            return;
        }

        this.#notificationElement.innerHTML = '';
    }

    #setErrorNotification(message: string): void {
        if (!this.#notificationElement) {
            return;
        }

        this.#notificationElement.innerHTML = statusPanelTemplate.render({
            variant: StatusPanelVariant.warning,
            label: message
        });
    }

    static getClassName(): string {
        return 'AcceptBookingComponent';
    }
}
